import { render } from "./OverlayHowItWorksVideo.vue?vue&type=template&id=13ca7eca"
import script from "./OverlayHowItWorksVideo.vue?vue&type=script&lang=js"
export * from "./OverlayHowItWorksVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__